import ModelProxy, {required, optional} from './proxy';


export class Mixture extends ModelProxy {

  static propTypes = {
    uuid: required,
    codonPosition: required,
    aa: required
  };

}


export class Insertion extends ModelProxy {

  static propTypes = {
    uuid: required,
    codonPosition: required,
    aa: required,
    na: required
  };

}


export default class Sequence extends ModelProxy {

  static propTypes = {
    uuid: required,
    accession: optional,
    isolateUuid: required,
    sequenceType: required,
    cloneName: optional,
    firstAa: optional,
    lastAa: optional,
    naseq: optional,
    aaseq: optional,
    mutationList: optional,
    mixtures: optional,
    insertions: optional
  };

  setMixtures(self, data) {
    self.props.mixtures = data.map(d => new Mixture(d));
  }

  setInsertions(self, data) {
    self.props.insertions = data.map(d => new Insertion(d));
  }

}



// WEBPACK FOOTER //
// ./src/models/sequence.js